import {createSlice} from "@reduxjs/toolkit";


const productsSlice = createSlice({
    name:"products",
    initialState:{
    list:[],
    },
    reducers:{
        addPProduct:(state,action)=>{
            state.list.push(action.payload);
        },
        setProducts:(state,action)=>{
            state.list = action.payload;
        }
    }
});

export const {addPProduct,setProducts} = productsSlice.actions;
export default productsSlice.reducer;